

document.addEventListener('DOMContentLoaded', function () {
    const buttons = document.querySelectorAll('.inner-tab-button');
    const contents = document.querySelectorAll('.inner-tab-content');

    buttons.forEach(button => {
      button.addEventListener('click', () => {
        const target = button.dataset.tab;

        buttons.forEach(btn => btn.classList.remove('active'));
        contents.forEach(content => content.classList.remove('active'));

        button.classList.add('active');
        document.getElementById(target).classList.add('active');
      });
    });
  });

// dropdown menu 
document.addEventListener('DOMContentLoaded', () => {
       function adjustDropdownPosition(dropdown) {
        const rect = dropdown.getBoundingClientRect();
        const viewportWidth = window.innerWidth || document.documentElement.clientWidth; // Use both for wider compatibility

        if (rect.right > viewportWidth) {
            dropdown.classList.add('flip-left');
        } else {
           if (dropdown.classList.contains('flip-left')) {
                dropdown.classList.remove('flip-left');
                const naturalRect = dropdown.getBoundingClientRect();
                if (naturalRect.right <= viewportWidth) {
                } else {
                    dropdown.classList.add('flip-left');
                }
            }
        }
    }

    document.querySelectorAll('.dropdown-parent').forEach(parentItem => {
        parentItem.addEventListener('mouseenter', () => {
            const submenu = parentItem.querySelector('.dropdown-menu, .dropdown-submenu');
            if (submenu) {
                requestAnimationFrame(() => {
                    adjustDropdownPosition(submenu);
                });
            }
        });

        parentItem.addEventListener('mouseleave', () => {
            const submenu = parentItem.querySelector('.dropdown-menu, .dropdown-submenu');
            if (submenu) {
                submenu.classList.remove('flip-left');
            }
        });

        parentItem.addEventListener('focusin', () => {
            const submenu = parentItem.querySelector('.dropdown-menu, .dropdown-submenu');
            if (submenu) {
                requestAnimationFrame(() => {
                    adjustDropdownPosition(submenu);
                });
            }
        });

        const parentDetails = parentItem.querySelector('details');
        if (parentDetails) {
            parentDetails.addEventListener('toggle', () => {
                const submenu = parentDetails.querySelector('.dropdown-menu'); // First level dropdown
                if (submenu && parentDetails.open) {
                    requestAnimationFrame(() => {
                        adjustDropdownPosition(submenu);
                    });
                }
            });
        }
    });

    window.addEventListener('resize', () => {
        document.querySelectorAll('.dropdown-menu, .dropdown-submenu').forEach(dropdown => {
            if (dropdown.offsetParent !== null) { 
                 requestAnimationFrame(() => {
                    adjustDropdownPosition(dropdown);
                });
            }
        });
    });
});

// mobile menu
  document.addEventListener('DOMContentLoaded', function() {
    function toggleSubmenu(trigger) {
      const isExpanded = trigger.getAttribute('aria-expanded') === 'true';
      trigger.setAttribute('aria-expanded', !isExpanded);
      
      const submenu = trigger.closest('.has-submenu').querySelector('.submenu');
      submenu.classList.toggle('active');
    }

    const toggles = document.querySelectorAll('.submenu-toggle');
    toggles.forEach(toggle => {
      toggle.addEventListener('click', function(e) {
        e.stopPropagation();
        toggleSubmenu(this);
      });
    });

    const triggers = document.querySelectorAll('[data-submenu-trigger]');
    triggers.forEach(trigger => {
      trigger.addEventListener('click', function(e) {
        if (e.target.tagName === 'A' && e.target.getAttribute('href') !== '#') {
          return;
        }
        
        const toggle = this.querySelector('.submenu-toggle');
        if (toggle) {
          e.preventDefault();
          e.stopPropagation();
          toggleSubmenu(toggle);
        }
      });
    });
  });
  // single posts bottom banner
  if(counter===undefined){var counter=0;}(function(){if(counter===0){counter++;var i;var h="https://req.easywebinar.com/";var cdnurl="https://req.easywebinar.com";function f(k,j){if("js"==j){var l=document.createElement("script");l.type="text/javascript",l.src=k,document.body.appendChild(l)}else{if("css"==j){var l=document.createElement("link");l.rel="stylesheet",l.href=k,document.head.appendChild(l)}}}f(cdnurl+"/widget/css/ewp-widget.css?v=151","css");f(cdnurl+"/widget/phone-code/css/intlTelInput.css?v=143","css"); if(window.jQuery===undefined || jQuery.fn.jquery=='1.4.2'){var a=document.createElement("script");a.setAttribute("type","text/javascript");a.setAttribute("src","https://code.jquery.com/jquery-3.2.1.min.js");if(a.readyState){a.onreadystatechange=function(){if(this.readyState=="complete"||this.readyState=="loaded"){g()}}}else{a.onload=g}(document.getElementsByTagName("head")[0]||document.documentElement).appendChild(a)}else{i=window.jQuery;e()}function g(){i=window.jQuery;e()}function e(){ if(window.jstz===undefined){var j=document.createElement("script");j.setAttribute("type","text/javascript");j.setAttribute("src","https://cdnjs.cloudflare.com/ajax/libs/jstimezonedetect/1.0.4/jstz.min.js");if(j.readyState){j.onreadystatechange=function(){if(this.readyState=="complete"||this.readyState=="loaded"){d()}}}else{j.onload=d}(document.getElementsByTagName("head")[0]||document.documentElement).appendChild(j)}else{d()}}function c(j){if(j>=0){return(parseInt(j,10)<10?"0":"")+j}else{return(parseInt(Math.abs(j),10)<10?"0":"")+Math.abs(j)}}function b(){var k=new Date();var j=k.getTimezoneOffset();j=parseFloat((-1)*(parseInt(j,10)/60)).toFixed(2);var m=j.split(".");var l=c(m[0])+":"+c(parseInt((m[1]*60)/100,10))+":00";var n="";if(parseInt(m[0],10)>=0){n="+"}else{n="-"}return{tzVal:l,tzOp:n}}function d(){f(cdnurl+"/widget/phone-code/js/intlTelInput.min.js?v=143","js"); i(document).ready(function(o){var q=(jstz)?jstz.determine():null;var k=(q)?encodeURIComponent(o.trim(q.name())):"";var p=b().tzVal;var n=b().tzOp;var j=h+"/widget/widget.php";var l=function(){o("body").hasClass("ewp_updated")||m(),o("body").hasClass("ewp_script_loaded")||(o("body").addClass("ewp_script_loaded"),wrap_count=0,o(".widget_wrapper_btn").each(function(){var u=(o(this),o(this).find(".ewp_widget_container")),t=o(this).find(".ew-md-overlay").attr("overlay_id",wrap_count);u.attr("container_id",wrap_count),o("body").append(t),t.append(u),o(this).find(".ewp_widget_container").remove(),o(this).find(".ew-md-overlay").remove(),u=o("body").find("[container_id="+wrap_count+"]");var v=o(this).find(".ewp_widget_btnid");v.attr("btn_id",wrap_count),v.css("cursor","pointer");var s=(document.querySelector('.ew-md-overlay[overlay_id="'+wrap_count+'"]'),o(this).find(".ew-md-trigger"));[].slice.call(s).forEach(function(y,A){function w(){var r;r=classie.has(y,"ew-md-setperspective"),z.removeClass("ew-md-show"),r&&document.documentElement.removeClass("ew-md-perspective")}var x=document.querySelector('[btn_id="'+wrap_count+'"]'),z=u;x.addEventListener("click",function(D){o("body").append('<div class="ewp_loading_">Loading&#8230;</div>');o("body").addClass("ewp_noscroll");var C=o(this).attr("btn_id"),F=o("body").find("[container_id="+C+"]"),B=F.attr("webinar_id").replace(/\s/g,"+"),E=j+"?wid="+B+"&ver_cache="+(new Date).getTime()+"&user_timezone="+(k)+"&timezone_difference="+(p)+"&timezone_operation="+(n);F.addClass("ew-md-show"),F.removeClass("ew-thankyou"),F.find(".ew-md-content").load(E,function(r){o(".ewp_Wigloader_wrap").hide();o(".ewp_loading_").hide();o('.ew-md-overlay[overlay_id="'+C+'"]').addClass("activePopup"),F.on("click",".ew-md-overlay",function(G){G.target===this&&(o("body").removeClass("ewp_noscroll"),o(".ew-md-overlay").removeClass("activePopup"),o("body").removeClass("ewp_noscroll"),G.preventDefault(),G.stopPropagation(),w())}),F.on("click",".ew-md-close",function(G){o("body").removeClass("ewp_noscroll"),o(".ew-md-overlay").hasClass("activePopup")&&o(".ew-md-overlay").removeClass("activePopup"),G.preventDefault(),G.stopPropagation(),w()});F.on("keypress",".ewp_widget_container input",function(G){return 13==G.which?(F.children().find(".ewp_submit").click(),!1):void 0})}),D.stopPropagation()})}),wrap_count++}))}();!function(w){function x(t){return new RegExp("(^|\\s+)"+t+"(\\s+|$)")}function z(t,A){var B=r(t,A)?y:v;B(t,A)}var r,v,y;"classList" in document.documentElement?(r=function(t,A){return t.classList.contains(A)},v=function(t,A){t.classList.add(A)},y=function(t,A){t.classList.remove(A)}):(r=function(t,A){return x(A).test(t.className)},v=function(t,A){r(t,A)||(t.className=t.className+" "+A)},y=function(t,A){t.className=t.className.replace(x(A)," ")});var u={hasClass:r,addClass:v,removeClass:y,toggleClass:z,has:r,add:v,remove:y,toggle:z};"function"==typeof define&&define.amd?define(u):w.classie=u}(window);function m(){var x=o("#ewp_widget_btnid");if(x.length){o("body").addClass("ewp_updated");var v=o("#ewp_widget_container").attr("webinar_id");x.closest("#ewp_widget_container").remove();var u=x.next(),w=x.next().next(),y=w.next(),z=y.attr("src");u.remove(),y.remove(),w.remove(),newWidgetHTML='<div class="widget_wrapper_btn"><button style="display:none" class="ew-md-trigger ewp_widget_btnid loader"></button><div class="ew-md-modal ewp_widget_container ew-md-effect-19" webinar_id="'+v+'" ></div><div class="ew-md-overlay"></div> <script type="text/javascript" src="'+z+'" ><\/script></div>',x.after(newWidgetHTML),x.remove()}else{var s=o("#ewp_widget_container");if(s.length){o("body").addClass("ewp_updated");var v=o("#ewp_widget_container").attr("webinar_id"),y=o("#ewp_widget_container").next(),z=y.attr("src");y.remove(),newWidgetHTML='<div class="widget_wrapper"><div class="ewp_form_container ewp_widget_container" webinar_id="'+v+'" ></div> <script type="text/javascript" src="'+z+'"><\/script></div>',s.after(newWidgetHTML),s.remove()}}}o(".widget_wrapper_btn").length>=1&&o(".widget_wrapper_btn").each(function(){var x=o(this).find(".ewp_widget_btnid").attr("btn_id"),v=o("body").find("[container_id="+x+"]"),u=o(this).find(".ewp_widget_btnid"),w=v.attr("webinar_id").replace(/\s/g,"+"),y=j+"?wid="+w+"&design=1&ver_cache="+(new Date).getTime()+Math.random()+"&user_timezone="+(k)+"&timezone_difference="+(p)+"&timezone_operation="+(n);var s=o(this);/*o(".ewp_widget_btnid").show();*/if(!v.hasClass("ew-dont-iterate")){s.append('<div class="ewp_Wigloader_wrap"><div class="ew_loader ew_loader_green"></div></div>');v.addClass("ew-dont-iterate");o.getJSON(y,function(z){try{ var fonfamily=z.widget_font_family.replace(" ", "+");var link=document.createElement('link');link.setAttribute('rel','stylesheet');link.setAttribute('type','text/css');link.setAttribute('href','https://fonts.googleapis.com/css?family='+fonfamily);document.head.appendChild(link);u.show().text(z.widget_button_txt.replace(/\\/g,"")).css({"background-color":z.widget_button_bg_color,color:z.widget_button_color,"font-family":z.widget_font_family,"font-size":z.widget_font_size+"px",border:"none",height:z.widget_button_height?z.widget_button_height+"px":"44px",width:z.widget_button_width?z.widget_button_width+"px":"100px","min-width":"220px","border-radius":"5px"}).removeClass("loader"),"2"==z.widget_layout_type?v.addClass("oncol"):v.addClass("twocol"),v.html('<div class="ew-md-content"></div>');var t=z.widget_font_family,A=z.widget_font_family.replace(" ","+");s.find(".ewp_Wigloader_wrap").remove()}catch(z){s.find(".ewp_Wigloader_wrap").remove()}})}}),o(".widget_wrapper").length>=1&&o(".widget_wrapper").each(function(){var w=o(this),u=w.find(".ewp_widget_container"),s=u.attr("webinar_id").replace(/\s/g,"+"),v=j+"?wid="+s+"&ver_cache="+(new Date).getTime()+Math.random()+"&user_timezone="+(k)+"&timezone_difference="+(p)+"&timezone_operation="+(n);if(!u.hasClass("ew-dont-iterate")){w.append('<div class="ewp_Wigloader_wrap"><div class="ew_loader ew_loader_green"></div></div>');u.addClass("ew-dont-iterate");u.load(v,function(r){w.find(".ewp_Wigloader_wrap").remove();w.on("keypress",".ewp_widget_container input",function(t){return 13==t.which?(w.children().find(".ewp_submit").click(),!1):void 0})})}}),o(document).on("keypress",".ewp_widget_container input",function(s){var r=o(this).parents(".ew-md-show.ewp_widget_container:first").find(".ewp_submit");return 13==s.which?(r.click(),!1):void 0})})}}})();

  // books slider

document.addEventListener("DOMContentLoaded", function() {
  let slideIndex = 0;
  const slides = document.querySelectorAll("#carousel1 .slide");
  const prevBtn = document.querySelector("#carousel1 .prev");
  const nextBtn = document.querySelector("#carousel1 .next");
  let autoSlide;

  function showSlide(index) {
    slides.forEach((slide, i) => {
      slide.style.display = (i === index) ? "block" : "none";
    });
  }

  function nextSlide() {
    slideIndex = (slideIndex + 1) % slides.length;
    showSlide(slideIndex);
  }

  function prevSlide() {
    slideIndex = (slideIndex - 1 + slides.length) % slides.length;
    showSlide(slideIndex);
  }

  // Auto play function
  function startAutoSlide() {
    autoSlide = setInterval(nextSlide, 4000); // 4000ms = 4 seconds
  }

  function stopAutoSlide() {
    clearInterval(autoSlide);
  }

  // Button events (reset timer when clicked)
  prevBtn.addEventListener("click", function() {
    prevSlide();
    stopAutoSlide();
    startAutoSlide();
  });

  nextBtn.addEventListener("click", function() {
    nextSlide();
    stopAutoSlide();
    startAutoSlide();
  });

  // Init
  showSlide(slideIndex);
  startAutoSlide();
});



